import { createContext, useContext } from "react";

import { PAPEvent } from "@mirage/analytics/events/base/event";
import { ActionSurfaceComponent } from "@mirage/analytics/events/enums/action_surface_component";
import type { ChatSource } from "@mirage/mosaics/Chat/types";

export interface MarkdownResponseContextInterface {
  referencingSources?: ChatSource[];
  conversationId?: string;
  logComposeEvent: (
    event: PAPEvent,
    overrides?: { actionSurfaceComponent?: ActionSurfaceComponent },
  ) => void;
  searchSessionId?: string;
  searchRequestId?: string;
  assistRequestId?: string;
}

export const MarkdownResponseContext =
  createContext<MarkdownResponseContextInterface | null>(null);

export const useMarkdownResponseContext = () => {
  const context = useContext(MarkdownResponseContext);
  if (!context) {
    throw new Error("MarkdownResponseContext not found");
  }
  return context;
};
